export enum BerthFieldTypes {
  Dry = 1,
  Gas = 2,
  Oil = 3,
}
